import { MutationHookOptions, useMutation } from '@apollo/client';

import { ADD_DISCUSSION } from './mutations';

export const useAddDiscussionAnswer = (options?: MutationHookOptions) => useMutation(ADD_DISCUSSION, options);
